import { trimEnv } from "@/lib/trimEnv";
import packageJson from "../../../package.json";

const DEFAULT_SERVICE = "pricer-webui";
const DEFAULT_SITE = "datadoghq.com";

export function isE2eTestMode(): boolean {
  return process.env.E2E_TEST_MODE === "1";
}

export function getDatadogSite(): string {
  return trimEnv(process.env.NEXT_PUBLIC_DD_SITE) ?? trimEnv(process.env.DD_SITE) ?? DEFAULT_SITE;
}

export function getDatadogEnv(): string | undefined {
  return trimEnv(process.env.NEXT_PUBLIC_DD_ENV) ?? trimEnv(process.env.DD_ENV);
}

export function getDatadogService(): string {
  return (
    trimEnv(process.env.NEXT_PUBLIC_DD_SERVICE) ??
    trimEnv(process.env.DD_SERVICE) ??
    DEFAULT_SERVICE
  );
}

export function getDatadogVersion(): string {
  return (
    trimEnv(process.env.DD_VERSION) ??
    trimEnv(process.env.NEXT_PUBLIC_DD_VERSION) ??
    packageJson.version
  );
}

export function getDatadogRumApplicationId(): string | undefined {
  return trimEnv(process.env.NEXT_PUBLIC_DD_RUM_APPLICATION_ID);
}

export function getDatadogRumClientToken(): string | undefined {
  return trimEnv(process.env.NEXT_PUBLIC_DD_RUM_CLIENT_TOKEN);
}

export function getDatadogRumSessionSampleRate(): number {
  const raw =
    trimEnv(process.env.NEXT_PUBLIC_DD_RUM_SESSION_SAMPLE_RATE) ??
    trimEnv(process.env.DD_RUM_SESSION_SAMPLE_RATE);
  if (!raw) {
    return 100;
  }
  const parsed = Number(raw);
  if (!Number.isFinite(parsed)) {
    return 100;
  }
  return Math.min(100, Math.max(0, parsed));
}

function parseSampleRate(raw: string | undefined, defaultValue: number): number {
  if (!raw) {
    return defaultValue;
  }
  const parsed = Number(raw);
  if (!Number.isFinite(parsed)) {
    return defaultValue;
  }
  return Math.min(100, Math.max(0, parsed));
}

export function getDatadogRumSessionReplaySampleRate(): number {
  const raw =
    trimEnv(process.env.NEXT_PUBLIC_DD_RUM_SESSION_REPLAY_SAMPLE_RATE) ??
    trimEnv(process.env.DD_RUM_SESSION_REPLAY_SAMPLE_RATE);
  return parseSampleRate(raw, 20);
}

export function isDatadogRumConfigured(): boolean {
  if (isE2eTestMode()) {
    return false;
  }
  return Boolean(getDatadogRumApplicationId() && getDatadogRumClientToken());
}

export function isDatadogLogsConfigured(): boolean {
  if (isE2eTestMode()) {
    return false;
  }
  return Boolean(getDatadogRumClientToken());
}

export function isDatadogTraceEnabled(): boolean {
  if (isE2eTestMode()) {
    return false;
  }
  if (trimEnv(process.env.DD_TRACE_ENABLED) === "false") {
    return false;
  }
  return Boolean(trimEnv(process.env.DD_API_KEY) || trimEnv(process.env.DD_AGENT_HOST));
}
